// Add your custom JS here.
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {SplitText} from "gsap/SplitText";
import {Loader} from "@googlemaps/js-api-loader";

gsap.registerPlugin(ScrollTrigger, SplitText);

// Animate from bottom
gsap.utils.toArray('.anim-up').forEach((el) => {
    gsap.from(el, {
        y: 50,
        opacity: 0,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
            trigger: el,
            start: "top 90%",
            toggleActions: "play none none none",
        },
    });
});

// Animate headings with SplitText
gsap.utils.toArray('.anim-heading').forEach(el => {
    const split = new SplitText(el, {type: "words"});

    gsap.from(split.words, {
        y: 50,
        opacity: 0,
        duration: 1,
        ease: "power2.out",
        stagger: 0.05,
        scrollTrigger: {
            trigger: el,
            start: "top 90%",
            toggleActions: "play none none none"
        }
    });
});

// Animate nav elements from top (on home)
if (document.body.classList.contains('home')) {
    gsap.utils.toArray('.anim-down').forEach((el) => {
        if (!el.classList.contains('anim-hero-banner')) {
            gsap.from(el, {
                y: -50,
                opacity: 0,
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: el,
                    start: "top 90%",
                    toggleActions: "play none none none",
                },
                delay: 0.5
            });
        }
    });
}

// Animate .anim-hero-banner globally
gsap.utils.toArray('.anim-hero-banner').forEach((el) => {
    gsap.from(el, {
        y: -50,
        opacity: 0,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
            trigger: el,
            start: "top 90%",
            toggleActions: "play none none none"
        },
        delay: 0.01
    });
});

// Modal javascript
document.addEventListener('DOMContentLoaded', function () {
    var imageModal = document.getElementById('imageModal');
    if (imageModal) {
        imageModal.addEventListener('show.bs.modal', function (event) {
            // Button that triggered the modal
            var button = event.relatedTarget;

            var imageUrl = button.getAttribute('data-bs-image');
            var materialTitle = button.getAttribute('data-material-title');
            var materialDescription = button.getAttribute('data-material-description');
            var materialGrade = button.getAttribute('data-material-grade');

            var modalImage = imageModal.querySelector('#modalImage');
            var modalTitle = imageModal.querySelector('#modalTitle');
            var modalDescription = imageModal.querySelector('#modalDescription');

            var gradeSection = imageModal.querySelector('#modalGrade').previousElementSibling;

            var modalGradeValue = imageModal.querySelector('#modalGrade');


            if (modalImage) modalImage.src = imageUrl;
            if (modalTitle) modalTitle.textContent = materialTitle;
            if (modalDescription) modalDescription.textContent = materialDescription;

            if (materialGrade) {
                gradeSection.style.display = 'block';
                modalGradeValue.style.display = 'block';
                modalGradeValue.textContent = materialGrade;
            } else {
                gradeSection.style.display = 'none';
                modalGradeValue.style.display = 'none';
                modalGradeValue.textContent = '';
            }
        });
    }
});

// Google maps
const loader = new Loader({
    apiKey: "AIzaSyCJFxXoQKNJ8MzXJSyckSjIC7TFHD5_x2A",
    version: "weekly"
});

loader.load()
    .then(async () => {
        const {Map} = await google.maps.importLibrary("maps");
        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

        const center = {lat: 39.76968939107778, lng: 22.286138906949542};

        const map = new Map(document.getElementById("map"), {
            center,
            zoom: 18,
            mapId: "d772d04d6760342dcef63fb0",
            mapTypeId: 'satellite',
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            cameraControl: false,
        });

        const pin = document.createElement('div');
        pin.style.width = '30px';
        pin.style.height = '40px';
        pin.style.backgroundImage = 'url(https://maps.google.com/mapfiles/ms/icons/green-dot.png)';
        pin.style.backgroundSize = 'contain';
        pin.style.backgroundRepeat = 'no-repeat';

        new AdvancedMarkerElement({
            map,
            position: center,
            content: pin,
            title: "Our Location",
        });
    })
    .catch(e => {
        console.error("Google Maps API failed to load", e);
    });
